<div class="attendance-clock-wrapper">
  <svg class="attendance-clock" viewBox="0 0 360 360">
    <!-- TEST DOT -->
    <!-- <circle cx="180" cy="180" r="5" fill="red"></circle> -->

    <!-- Background -->
    <circle cx="180" cy="180" r="120" class="clock-bg"></circle>

    <!-- Progress arcs -->
    <circle
      *ngFor="let arc of arcs"
      class="clock-arc"
      cx="180"
      cy="180"
      r="120"
      fill="none"
      [style.stroke]="arc.color"
      stroke-width="28"
      stroke-linecap="round"
      [attr.stroke-dasharray]="arc.length + ' 754'"
      [attr.stroke-dashoffset]="arc.offset"
      transform="rotate(-90 180 180)"
    ></circle>

    <!-- Clock Numbers -->
    <text
      *ngFor="let hour of clockHours; let i = index"
      [attr.x]="getLabelX(i)"
      [attr.y]="getLabelY(i)"
      fill="#000"
      font-size="14"
      text-anchor="middle"
      dominant-baseline="middle"
    >
      {{ hour }}
    </text>

    <text x="180" y="170" class="center-title">Total</text>

    <text x="180" y="205" class="center-value">
      {{ totalHours }}
    </text>
  </svg>

  <div class="legend">
    <div>
      <span class="dot productive"></span>
      Productive
    </div>

    <div>
      <span class="dot break"></span>
      Break
    </div>

    <div>
      <span class="dot overtime"></span>
      Overtime
    </div>
  </div>
</div>
